<template>
  <v-dialog v-model="visible" max-width="900px">
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">{{ titulo }}</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-form>
          <v-row dense>
            <v-col cols="12">
              <vue-select
                v-model="form.moduloId"
                class="style-chooser"
                placeholder="Seleccione un Módulo"
                :options="modulos"
                label="nombre"
                :reduce="(option) => option.id"
                :filterable="false"
                :append-to-body="true"
                @search="buscarModulos">
                <template #header>
                  <div>Módulo (Buscar por Nombre)</div>
                </template>

                <template #option="{ nombre }">
                  <div style="margin-bottom: 0.25rem">
                    <span style="display: block; font-size: 1rem">
                      {{ nombre }}
                    </span>
                  </div>
                </template>
              </vue-select>

              <small v-for="error in errores.moduloId" :key="error" class="d-inline-block text-danger">
                {{ error }}
              </small>
            </v-col>

            <v-col cols="12">
              <vue-select
                v-model="form.docenteId"
                class="style-chooser"
                placeholder="Seleccione un Docente"
                :options="docentesEncontrados"
                label="nombreCompleto"
                :reduce="(option) => option.id"
                :filterable="false"
                :append-to-body="true"
                @search="buscarDocentes">
                <template #header>
                  <div>Docente (Buscar por N° Documento, Nombres y Apellidos)</div>
                </template>

                <template #option="{ numeroDocumento, nombres, primerApellido, segundoApellido, profesiones, grados }">
                  <div style="margin-bottom: 0.25rem">
                    <span style="display: block; font-size: 1rem">
                      {{ numeroDocumento }} - {{ nombres }} {{ primerApellido }} {{ segundoApellido }}
                    </span>
                    <small style="display: block">
                      <strong>Profesiones: </strong>{{ profesiones.map((p) => p.nombre).join(', ') || '-' }}
                    </small>
                    <small style="display: block">
                      <strong>Grados Acad.: </strong>{{ grados.map((g) => g.nombre).join(', ') || '-' }}
                    </small>
                  </div>
                </template>
              </vue-select>

              <small v-for="error in errores.docenteId" :key="error" class="d-inline-block text-danger">
                {{ error }}
              </small>
            </v-col>

            <v-col cols="12" lg="4">
              <v-text-field
                v-model="form.numero"
                type="number"
                min="1"
                label="Número de Módulo"
                required
                outlined
                dense
                hide-details
                clearable></v-text-field>

              <small v-for="error in errores.numero" :key="error" class="d-block text-danger">{{ error }}</small>
            </v-col>

            <v-col cols="12" lg="4">
              <v-text-field
                v-model="form.cargaHorariaPresencial"
                type="number"
                min="0"
                label="Carga Horaria Presencial"
                required
                outlined
                dense
                hide-details
                clearable></v-text-field>

              <small v-for="error in errores.cargaHorariaPresencial" :key="error" class="d-block text-danger">
                {{ error }}
              </small>
            </v-col>

            <v-col cols="12" lg="4">
              <v-text-field
                v-model="form.cargaHorariaNoPresencial"
                type="number"
                min="0"
                label="Carga Horaria No Presencial"
                required
                outlined
                dense
                hide-details
                clearable></v-text-field>

              <small v-for="error in errores.cargaHorariaNoPresencial" :key="error" class="d-block text-danger">
                {{ error }}
              </small>
            </v-col>

            <v-col cols="12" lg="4">
              <v-menu
                ref="menuFechaInicioRef"
                v-model="menuFechaInicio"
                transition="scale-transition"
                :close-on-content-click="false"
                offset-y
                min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.fechaInicio"
                    label="Fecha Inicio"
                    prepend-icon="mdi-calendar"
                    outlined
                    dense
                    hide-details
                    readonly
                    clearable
                    v-bind="attrs"
                    v-on="on"></v-text-field>
                </template>

                <v-date-picker v-model="form.fechaInicio" no-title scrollable @input="menuFechaInicio = false">
                  <v-spacer></v-spacer>

                  <v-btn text color="primary" @click="menu = menuFechaInicio"> Cancelar </v-btn>

                  <v-btn text color="primary" @click="$refs.menuFechaInicioRef.save(form.fechaInicio)"> Aceptar </v-btn>
                </v-date-picker>
              </v-menu>

              <small v-for="error in errores.fechaInicio" :key="error" class="d-inline-block text-danger">
                {{ error }}
              </small>
            </v-col>

            <v-col cols="12" lg="4">
              <v-menu
                ref="menuFechaFinRef"
                v-model="menuFechaFin"
                transition="scale-transition"
                :close-on-content-click="false"
                offset-y
                min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.fechaFin"
                    label="Fecha Inicio"
                    prepend-icon="mdi-calendar"
                    outlined
                    dense
                    hide-details
                    readonly
                    clearable
                    v-bind="attrs"
                    v-on="on"></v-text-field>
                </template>

                <v-date-picker v-model="form.fechaFin" no-title scrollable @input="menuFechaFin = false">
                  <v-spacer></v-spacer>

                  <v-btn text color="primary" @click="menu = menuFechaFin"> Cancelar </v-btn>

                  <v-btn text color="primary" @click="$refs.menuFechaFinRef.save(form.fechaFin)"> Aceptar </v-btn>
                </v-date-picker>
              </v-menu>

              <small v-for="error in errores.fechaFin" :key="error" class="d-inline-block text-danger">
                {{ error }}
              </small>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click.prevent="cerrar"> Cerrar </v-btn>

        <v-btn
          color="blue darken-1"
          text
          :loading="enviando"
          :disabled="enviando"
          @click.prevent="validar(registrar, editar)">
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import 'vue-select/dist/vue-select.css';
import ModuloProgramaService from '../services/modulo-programa.service';
import modalFormMixin from '../mixins/modal-form.mixin';
import apiConsumerMixin from '../mixins/api-consumer.mixin';
import ModuloServce from '../services/modulo.service';
import PersonaService from '../services/persona.service';

export default {
  name: 'ModalFormularioModulosPrograma',
  mixins: [modalFormMixin, apiConsumerMixin],
  props: {
    programaUniversidadId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      modulos: [],
      retardoBusquedaModulo: null,
      busquedaModulo: null,
      docentes: [],
      retardoBusquedaDocente: null,
      busquedaDocente: null,
      menuFechaInicio: false,
      menuFechaFin: false,
    };
  },
  watch: {
    'form.moduloId': function () {
      this.errores.moduloId = [];
    },
    'form.docenteId': function () {
      this.errores.docenteId = [];
    },
    'form.numero': function () {
      this.errores.numero = [];
    },
    'form.cargaHorariaPresencial': function () {
      this.errores.cargaHorariaPresencial = [];
    },
    'form.cargaHorariaNoPresencial': function () {
      this.errores.cargaHorariaNoPresencial = [];
    },
    'form.fechaInicio': function () {
      this.errores.fechaInicio = [];
    },
    'form.fechaFin': function () {
      this.errores.fechaFin = [];
    },
  },
  computed: {
    docentesEncontrados() {
      return this.docentes.map((docente) => ({
        ...docente,
        nombreCompleto: `${docente.numeroDocumento} - ${docente.nombres} ${docente.primerApellido || ''} ${
          docente.segundoApellido || ''
        }`,
      }));
    },
  },
  methods: {
    generarObjetoFormRegistrar() {
      return {
        id: null,
        programaUniversidadId: this.programaUniversidadId,
        moduloId: null,
        modulo: null,
        docenteId: null,
        docente: null,
        numero: null,
        cargaHorariaPresencial: null,
        cargaHorariaNoPresencial: null,
        fechaInicio: null,
        fechaFin: null,
      };
    },
    generarObjetoFormEditar(data) {
      return {
        id: data.id,
        programaUniversidadId: data.programaUniversidadId,
        moduloId: data.moduloId,
        modulo: data.modulo,
        docenteId: data.docenteId,
        docente: data.docente,
        numero: data.numero,
        cargaHorariaPresencial: data.cargaHorariaPresencial,
        cargaHorariaNoPresencial: data.cargaHorariaNoPresencial,
        fechaInicio: data.fechaInicio,
        fechaFin: data.fechaFin,
      };
    },
    async obtenerModulos() {
      const params = {
        busqueda: this.busquedaModulo || null,
        itemsPorPagina: 25,
        pagina: 1,
      };

      await this.obtenerDatosMixin(ModuloServce.findAll, 'modulos', params, () => {
        this.modulos = [];
      });
    },
    async obtenerDocentes() {
      const params = {
        busqueda: this.busquedaDocente || null,
        itemsPorPagina: 25,
        pagina: 1,
      };

      await this.obtenerDatosMixin(PersonaService.findAll, 'docentes', params, () => {
        this.docentes = [];
      });
    },
    abrir(accion, data = []) {
      if (accion == this.accionesCrud.EDITAR) {
        if (data.moduloId) {
          this.modulos = [];
          this.busquedaModulo = data.modulo.nombre;
          this.obtenerModulos();
        }

        if (data.docenteId) {
          this.docentes = [];
          this.busquedaDocente = data.docente.numeroDocumento;
          this.obtenerDocentes();
        }
      }

      this.abrirMixin(accion, data);
    },
    guardar(accion) {
      this.guardarDatosMixin(
        ModuloProgramaService.create,
        ModuloProgramaService.update,
        accion,
        this.form,
        this.nombreRecurso,
        () => {
          this.$emit('actualizarListado');
          this.cerrar();
        },
        (errores) => {
          this.errores = errores;
        },
      );
    },
    registrar() {
      this.guardar(this.accionesCrud.REGISTRAR);
    },
    editar() {
      this.guardar(this.accionesCrud.EDITAR);
    },
    buscarModulos(search, loading) {
      if (!search.length) {
        return;
      }

      clearTimeout(this.retardoBusquedaModulo);

      this.busquedaModulo = search;

      this.retardoBusquedaModulo = setTimeout(() => {
        loading(true);
        this.obtenerModulos().finally(() => loading(false));
      }, 500);
    },
    buscarDocentes(search, loading) {
      if (!search.length) {
        return;
      }

      clearTimeout(this.retardoBusquedaDocente);

      this.busquedaDocente = search;

      this.retardoBusquedaDocente = setTimeout(() => {
        loading(true);
        this.obtenerDocentes().finally(() => loading(false));
      }, 500);
    },
  },
};
</script>

<style scoped>
::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 0px 0;
}

::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}

::v-deep .v-text-field .v-label {
  font-weight: 400;
}
</style>
